import React from 'react'
import styles from './FinancialServices.module.css';
import IconsSocial from '../Social-icons/IconsSocial';
import './styles.css';
import { useNavigate } from 'react-router-dom';

function FinancialSectors() {
    const navigate = useNavigate(); // Access the history object

    const handleNavigation = (pageNumber) => {

        navigate(`/financialSectors/weserve?pagenumb=${pageNumber}`);
    };
    return (

        <div className={styles.section2} style={{ flexDirection: 'row-reverse' }}>


            <div className={styles.leftCont}>
                <div style={{ display: 'flex', alignItems: 'center', height: '33vh' }}>
                    <div className={styles.textContent}>
                        <h1 className={styles.mainTitleWhite2}>القطاعات  </h1>
                        <h1 className={styles.mainTitleYellow2}>التي نخدمها</h1>
                    </div>   </div>
                <div className={styles.rightBottomCont} style={{ flexDirection: 'row-reverse' }}>

                    <div className={` ${styles.serBox2}`} onClick={() => handleNavigation(3)}>
                        <div><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                            <g clip-path="url(#clip0_1074_540)">
                                <path d="M7.5 30H10M30 7.5V10M50 30H52.5M14 14L15.75 15.75M46 14L44.25 15.75" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M22.5 40C20.4012 38.4259 18.8508 36.2313 18.0686 33.7271C17.2863 31.2229 17.3118 28.5361 18.1415 26.0472C18.9711 23.5583 20.5628 21.3935 22.6911 19.8595C24.8194 18.3255 27.3765 17.5 30 17.5C32.6235 17.5 35.1806 18.3255 37.3089 19.8595C39.4372 21.3935 41.0289 23.5583 41.8585 26.0472C42.6882 28.5361 42.7137 31.2229 41.9314 33.7271C41.1492 36.2313 39.5988 38.4259 37.5 40C36.5239 40.9662 35.789 42.1486 35.3547 43.4516C34.9204 44.7545 34.7989 46.1414 35 47.5C35 48.8261 34.4732 50.0979 33.5355 51.0355C32.5979 51.9732 31.3261 52.5 30 52.5C28.6739 52.5 27.4021 51.9732 26.4645 51.0355C25.5268 50.0979 25 48.8261 25 47.5C25.2011 46.1414 25.0796 44.7545 24.6453 43.4516C24.211 42.1486 23.4761 40.9662 22.5 40Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M24.25 42.5H35.75" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1074_540">
                                    <rect width="60" height="60" fill="white" />
                                </clipPath>
                            </defs>
                        </svg></div>
                        <div className={styles.boxTitle2}>
                            <h5>
                                التكنولوجيا و الاتصالات
                            </h5>
                        </div>
                    </div>

                    <div className={` ${styles.serBox2}`} onClick={() => handleNavigation(4)} >
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                                <g clip-path="url(#clip0_1074_952)">
                                    <path d="M10 42.5C10 43.8261 10.5268 45.0979 11.4645 46.0355C12.4021 46.9732 13.6739 47.5 15 47.5C16.3261 47.5 17.5979 46.9732 18.5355 46.0355C19.4732 45.0979 20 43.8261 20 42.5C20 41.1739 19.4732 39.9021 18.5355 38.9645C17.5979 38.0268 16.3261 37.5 15 37.5C13.6739 37.5 12.4021 38.0268 11.4645 38.9645C10.5268 39.9021 10 41.1739 10 42.5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M40 42.5C40 43.8261 40.5268 45.0979 41.4645 46.0355C42.4021 46.9732 43.6739 47.5 45 47.5C46.3261 47.5 47.5979 46.9732 48.5355 46.0355C49.4732 45.0979 50 43.8261 50 42.5C50 41.1739 49.4732 39.9021 48.5355 38.9645C47.5979 38.0268 46.3261 37.5 45 37.5C43.6739 37.5 42.4021 38.0268 41.4645 38.9645C40.5268 39.9021 40 41.1739 40 42.5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 42.5H5V15C5 14.337 5.26339 13.7011 5.73223 13.2322C6.20107 12.7634 6.83696 12.5 7.5 12.5H42.5C45.8152 12.5 48.9946 14.3437 51.3388 17.6256C53.683 20.9075 55 25.3587 55 30V42.5H50M40 42.5H20" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M40 12.5L43.75 30H55" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M5 25H42.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M17.5 12.5V25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M30 12.5V25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1074_952">
                                        <rect width="60" height="60" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div className={styles.boxTitle2}>
                            <h5> خدمات النقل  </h5>

                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.rightCont}>

                <div className={styles.rightTopCont} style={{ flexDirection: 'row-reverse' }}>
                    <div className={` ${styles.serBox2}`} onClick={() => handleNavigation(1)}>

                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                                <g clip-path="url(#clip0_1074_1190)">
                                    <path d="M10 52.5C12.8675 42.45 14.9575 32.4325 15 22.5H30C30.0425 32.4325 32.1325 42.45 35 52.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M31.25 32.5H42.5C42.5625 39.03 44.735 45.74 47.5 52.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M22.5 12.5C23.0679 11.7087 23.8199 11.0677 24.6911 10.6321C25.5622 10.1965 26.5263 9.97958 27.5 9.99997C28.4737 9.97958 29.4378 10.1965 30.3089 10.6321C31.1801 11.0677 31.9321 11.7087 32.5 12.5C33.0679 13.2912 33.8199 13.9323 34.6911 14.3679C35.5622 14.8034 36.5263 15.0204 37.5 15C38.4737 15.0204 39.4378 14.8034 40.3089 14.3679C41.1801 13.9323 41.9321 13.2912 42.5 12.5C43.0679 11.7087 43.8199 11.0677 44.6911 10.6321C45.5622 10.1965 46.5263 9.97958 47.5 9.99997C48.4737 9.97958 49.4378 10.1965 50.3089 10.6321C51.1801 11.0677 51.9321 11.7087 52.5 12.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.5 52.5H55" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1074_1190">
                                        <rect width="60" height="60" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div className={styles.boxTitle2}>
                            <h5>الصناعة </h5>
                        </div>

                    </div>
                    <div className={` ${styles.serBox2}`} onClick={() => handleNavigation(2)} >
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                                <g clip-path="url(#clip0_653_4045)">
                                    <path d="M7.5 30C7.5 32.9547 8.08198 35.8806 9.21271 38.6104C10.3434 41.3402 12.0008 43.8206 14.0901 45.9099C16.1794 47.9992 18.6598 49.6566 21.3896 50.7873C24.1194 51.918 27.0453 52.5 30 52.5C32.9547 52.5 35.8806 51.918 38.6104 50.7873C41.3402 49.6566 43.8206 47.9992 45.9099 45.9099C47.9992 43.8206 49.6566 41.3402 50.7873 38.6104C51.918 35.8806 52.5 32.9547 52.5 30C52.5 24.0326 50.1295 18.3097 45.9099 14.0901C41.6903 9.87053 35.9674 7.5 30 7.5C24.0326 7.5 18.3097 9.87053 14.0901 14.0901C9.87053 18.3097 7.5 24.0326 7.5 30Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9 22.5H51" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9 37.5H51" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M28.7502 7.5C24.5385 14.249 22.3057 22.0447 22.3057 30C22.3057 37.9553 24.5385 45.751 28.7502 52.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M31.25 7.5C35.4616 14.249 37.6945 22.0447 37.6945 30C37.6945 37.9553 35.4616 45.751 31.25 52.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_653_4045">
                                        <rect width="60" height="60" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div className={styles.boxTitle2}>
                            <h5>
                                التجارة
                            </h5>
                        </div>
                    </div>
                </div>
                <div className={styles.rightBottomCont} style={{ flexDirection: 'row-reverse' }}>
                    <div className={` ${styles.serBox2}`} onClick={() => handleNavigation(5)} >
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                                <g clip-path="url(#clip0_1074_229)">
                                    <path d="M15 52.5H30" stroke="white" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M22.5 52.5V7.5L7.5 22.5H52.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M22.5 7.5L47.5 22.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M42.5 22.5V32.5C43.4889 32.5 44.4556 32.7932 45.2779 33.3427C46.1001 33.8921 46.741 34.673 47.1194 35.5866C47.4978 36.5002 47.5969 37.5055 47.4039 38.4755C47.211 39.4454 46.7348 40.3363 46.0355 41.0355C45.3363 41.7348 44.4454 42.211 43.4755 42.4039C42.5055 42.5969 41.5002 42.4978 40.5866 42.1194C39.673 41.741 38.8921 41.1001 38.3427 40.2779C37.7932 39.4556 37.5 38.4889 37.5 37.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1074_229">
                                        <rect width="60" height="60" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div className={styles.boxTitle2}>
                            <h5> المقاولات </h5>
                        </div>
                    </div>
                    <div style={{ alignItems: 'center', display: 'flex' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', gap: '5%' }}>
                            <span className={styles.NumWhite2}>المزيد</span><span className={styles.NumYellow2}> + </span>

                        </div>
                    </div>

                </div>


            </div>


        </div>


    )
}

export default FinancialSectors